module.exports = __webpack_public_path__ + "static/squares2-8f506300ac701dbdedb8263b1d3b97e7.svg";